<script>
    import Error403 from './../components/Error403.svelte';
    import {onMount} from 'svelte';

    import AuthService from '../services/auth.service';
    import ReportsService from '../services/reports.service';
    import OrganizationsService from '../services/organizations.service';
    import AlteryxService from '../services/alteryx.service';
    import Loader from '../components/Loader.svelte';
    import ApiReportsService from '../services/apiReports.service';
    import PasswordValidator from '../components/PasswordValidator.svelte';

    let loading = false, externals = [], permissions = [], organizations = [], selectedOrganization = null,
        tab = 'hr', alteryxEmails = '', isAlteryxAllowed, apiReportsEmails = '', isApiReportsAllowed, userToDelete = {};
    let message = {
        show: false,
        type: '',
        text: ''
    }
    let validPassword = {
        dirty: false,
        valid: true,
        errors: []
    }
    let sections = {
        'HR': 'Human Resources',
    };
    let externalUser = {
        name: '',
        email: '',
        password: ''
    };
    let externalUserErrorMessage = {
        show: false,
        type: '',
        text: ''
    }

    onMount(async () => {
        if (!AuthService.can('SET_HR_PERMISSIONS') && AuthService.canShow('talent_tracking')) tab = 'external_users';
        organizations = await OrganizationsService.list();
        selectedOrganization = organizations[0];
        await userAllowed();
        if (isApiReportsAllowed) getApiReportsAllowed();
        if (isAlteryxAllowed) getAlteryxEmailsAllowed();
        await getExternals();
        await getUsers();
    });

    async function getUsers() {
        permissions = [];

        if (selectedOrganization){
            var result = null;
            loading = true;
            try {
                result = await ReportsService.getUsersPermissions(selectedOrganization.id);
                if (result && result.data && Array.isArray(result.data)) {
                    permissions = result.data.filter((permission) => {
                        return permission.user && permission.user.name && permission.user.active === 1;
                    });
                }
            } catch (e) {
                console.log('Error', e);
            } finally{
                loading = false;
            }
        }
    }

    async function getExternals() {
        externals = [];
        var result = null;
        loading = true;
        try {
            result = await ReportsService.getExternalUsers(selectedOrganization.id);
            if (result && result.data && Array.isArray(result.data)) {
                externals = result.data.filter((user) => {
                    return user.id && user.name;
                });
            }
        } catch (e) {
            console.log('Error', e);
        } finally{
            loading = false;
        }
    }

    async function changePermission(organization_id, user_id, section, value){
        try {
            await ReportsService.updatePermission(organization_id, user_id, section, value);
        } catch (e) {
            console.log('Error', e);
        }
    }

    function change(organization) {
        selectedOrganization = organization;
        getUsers();
    }

    const updateAlteryxEmails = async function() {
        loading = true;
        try {
            const response = await AlteryxService.updateEmailsAllowed({ emails: alteryxEmails });

            if (response && response.data.ok) {
                message = {
                    show: true,
                    text: 'Email accounts updated',
                    type: 'success'
                }
            }else{
                message = {
                    show: true,
                    text: 'Error: ' + response.data.error,
                    type: 'danger'
                }
            }
        } catch (e) {
            message = {
                show: true,
                text: 'Error: ' + e.message,
                type: 'danger'
            }
        } finally {
            loading = false;
        }
    }

    const updateApiUsersAllowed = async function () {
        loading = true;
        try {
            const response = await ApiReportsService.updateEmails({ emails: apiReportsEmails });

            if (response && response.data.ok) {
                message = {
                    show: true,
                    text: 'Email accounts updated',
                    type: 'success'
                }
            }else{
                message = {
                    show: true,
                    text: 'Error: ' + response.data.error,
                    type: 'danger'
                }
            }
        } catch (e) {
            message = {
                show: true,
                text: 'Error: ' + e.message,
                type: 'danger'
            }
        } finally {
            loading = false;
        }
    }

    const resetMessage = function(){
        message = {
            show: false,
            text: '',
            type: ''
        }
    }

    async function getAlteryxEmailsAllowed() {
        loading = true;
        try {
            const response = await AlteryxService.getEmailsAllowed();

            if (response && response) alteryxEmails = response;
        } catch (e) {
            errorMessage = e.message;
        } finally {
            loading = false;
        }
    }

    const getApiReportsAllowed = async function() {
        loading = true;
        try {
            const response = await ApiReportsService.getEmails();

            if (response && response) apiReportsEmails = response;
        } catch (e) {
            errorMessage = e.message;
        } finally {
            loading = false;
        }
    }

    //Verify if user has permission to see this section
    async function userAllowed() {
        loading = true;
        try {
            // Alteryx allowed
            const alteryxPermissionResponse = await AlteryxService.isAllowed();
            if (alteryxPermissionResponse && alteryxPermissionResponse.data.ok) isAlteryxAllowed = alteryxPermissionResponse.data.ok;
            // Api reports allowed
            const apiReportPermissionResponse = await ApiReportsService.isAllowed();
            if (apiReportPermissionResponse && apiReportPermissionResponse.data.ok) isApiReportsAllowed = apiReportPermissionResponse.data.ok;
        } catch (e) {
            errorMessage = e.message;
        } finally {
            loading = false;
        }
    }

    async function onAddUserClick() {
        cleanExternalUser();
        jQuery('#addExternalUser').modal('show');
    }

    async function onExternalUserSave() {
        externalUserErrorMessage = {
            show: false,
            type: '',
            message: ''
        }
        try {
            const response = await ReportsService.saveExternalUser(externalUser);

            if (response && response.data && response.data.id) {
                jQuery('#addExternalUser').modal('hide');
                await getExternals();
            } else {
                externalUserErrorMessage = {
                    show: true,
                    text: 'Error: ' + response.data.error,
                    type: 'danger'
                }
            }
        } catch (e) {
            externalUserErrorMessage = {
                show: true,
                type: 'error',
                text: e.message
            };
        }
    }

    async function toggleExternalUser(id) {
        try {
            await ReportsService.toogleExternalUser(id);
        } catch (e) {
            console.log('Error', e);
        } finally {
            await getExternals();
        }
    }

    async function deleteExternalUser(ext) {
        userToDelete = {
            id: ext.id,
            name: ext.name
        }
        jQuery('#deleteUserModal').modal('show');
    }

    async function deleteUser() {
        try {
            await ReportsService.deleteExternalUser(userToDelete.id);
        } catch (e) {
            console.log('Error', e);
        } finally {
            jQuery('#deleteUserModal').modal('hide');
            await getExternals();
        }
    }

    async function cleanExternalUser() {
        externalUser = {
            name: '',
            email: '',
            password: ''
        };
    }

    function verifyPassword(password) {
        // fix problem, this function is called once on load with the following value "123123"
        if ((!password || password === '123123') && !validPassword.dirty) return;
        validPassword = {
            dirty: true,
            valid: false,
            errors: []
        }
        if (password.length < 8 || password.length > 20) validPassword.errors.push('Password length must be of 8-20 characters');

        // At least one uppercase, one lowercase and one number
        const hasUppercase = /[A-Z]/.test(password);
        const hasLowercase = /[a-z]/.test(password);
        const hasNumber = /\d/.test(password);
        if (!hasUppercase || !hasLowercase) validPassword.errors.push('Password must include upper and lowercase letters');
        if (!hasNumber) validPassword.errors.push('Password must include at least one number');
        if (validPassword.errors.length === 0) validPassword.valid = true;
    }

    function passwordChanged(password) {
        externalUser.password = password;
    }
</script>

<!-- Delete User Modal -->
<div class="modal fade" id="deleteUserModal" tabindex="-1" role="dialog" aria-labelledby="deleteUsermodal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteUserLabel">
                    <i class="text-danger fa fa-exclamation-triangle ml-1"></i> WARNING!
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>Are you sure you want to delete <b>{userToDelete.name}</b>?</p>
            </div>
            <div class="modal-footer text-right">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cancel</button>
                <button type="button" class="btn btn-danger " on:click={() => deleteUser()} >
                    Confirm
                </button>
            </div>
        </div>
    </div>
</div>

<main class="pt-3 container">
    <div class="row">
        <div class="col">
            {#if !AuthService.can('SET_HR_PERMISSIONS') && !AuthService.canShow('talent_tracking') }
                <Error403></Error403>
            {:else}
                {#if isAlteryxAllowed || !isApiReportsAllowed || AuthService.canShow('talent_tracking')}
                    <ul class="nav nav-pills nav-fill mb-3">
                        {#if AuthService.can('SET_HR_PERMISSIONS')}
                            <li class="nav-item">
                                <button class="general-tabs btn-block btn-default  {(tab === 'hr')?'active':''}" on:click={ () => tab = 'hr'}>HR</button>
                            </li>
                        {/if}
                        {#if AuthService.canShow('talent_tracking')}
                            <li class="nav-item">
                                <button class="general-tabs btn-block btn-default  {(tab === 'external_users')?'active':''}" on:click={ () => tab = 'external_users'}>External Users</button>
                            </li>
                        {/if}
                        {#if isAlteryxAllowed}
                             <li class="nav-item">
                                 <button class="general-tabs btn-block btn-default  {(tab === 'alteryx')?'active':''}" on:click={ () => tab = 'alteryx'}>Alteryx</button>
                             </li>
                        {/if}
                        {#if isApiReportsAllowed}
                             <li class="nav-item">
                                 <button class="general-tabs btn-block btn-default  {(tab === 'api_access')?'active':''}" on:click={ () => tab = 'api_access'}>API Access</button>
                             </li>
                        {/if}
                    </ul>
                {/if}
                {#if loading}
                    <Loader></Loader>
                {:else}
                    {#if message.show}
                        <div class="alert alert-{message.type} mt-3" id="message" role="alert">
                            {message.text}
                            <span class="float-right pointer" on:click={ resetMessage }>x</span>
                        </div>
                    {/if}
                    <div class="row">
                        <div class="col">
                            <p>
                                <a class="navbar-brand" href="/dashboard"><small><i class="fa fa-angle-left"></i> Back to the Dashboard</small></a>
                            </p>
                        </div>
                    </div>
                    {#if tab === 'hr'}
                        <div class="row">
                            <div class="col-3 mb-2">
                                <h4>Human Resources</h4>
                                {#if organizations.length > 0}
                                    <div class="dropdown mb-2 btn-block">
                                        <button class="btn btn-primary btn-block dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            {selectedOrganization.name}
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" id="permissions-org-list">
                                            {#each organizations as organization}
                                                <label class="dropdown-item" on:click={ () => change(organization) }>
                                                    {organization.name}
                                                </label>
                                            {/each}
                                        </div>
                                    </div>
                                {/if}
                            </div>
                        </div>
                        {#if AuthService.can('SET_HR_PERMISSIONS') }
                            <div class="row" id="hr-permissions-div">
                                <div class="col-md-12">
                                    {#each Object.keys(sections) as id}
                                        <table class="table mb-2">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th class="text-center">Allow</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {#if permissions.length === 0}
                                                <tr>
                                                    <td colspan="3">
                                                        No users where found in this organization.
                                                    </td>
                                                </tr>
                                            {/if}
                                            {#each permissions as permission}
                                                {#if permission.section === id}
                                                    <tr>
                                                        <td>{permission.user.name}</td>
                                                        <td>{permission.user.email}</td>
                                                        <td class="text-center">
                                                            <input type="checkbox" checked={permission.level > 0} on:change={ (e) => changePermission(permission.organization_id, permission.user_id, id, permission.level > 0? 0: 1)}>
                                                        </td>
                                                    </tr>
                                                {/if}
                                            {/each}
                                            </tbody>
                                        </table>
                                    {/each}
                                </div>
                            </div>
                        {/if}
                    {:else if tab === 'external_users'}
                        <div class="row">
                            <div class="col-6 mb-2">
                                <h4>External Users</h4>
                            </div>
                            <div class="col-6 mb-2">
                                <button class="btn btn-primary float-right" on:click={onAddUserClick}>
                                    <i class="fa fa-plus"></i>
                                    New User
                                </button>
                            </div>
                        </div>
                        {#if AuthService.canShow('talent_tracking') }
                            <div class="row" id="hr-permissions-div">
                                <div class="col-md-12">
                                    <table class="table mb-2">
                                        <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th class="text-right">Allow</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {#if externals.length === 0}
                                            <tr>
                                                <td colspan="3">
                                                    No users where found in this organization.
                                                </td>
                                            </tr>
                                        {/if}
                                        {#each externals as ext}
                                            <tr class={ext.active === 0? 'text-muted': ''}>
                                                <td>{ext.name}</td>
                                                <td>{ext.email}</td>
                                                <td class="text-right">
                                                    <input type="checkbox" checked={ext.active === 1} on:change={ (e) => toggleExternalUser(ext.id)}>
                                                    <div class="btn btn-sm btn-light py-0 mb-2" on:click={ (e) => deleteExternalUser(ext)}>
                                                        <div class="fa fa-trash text-danger"></div>
                                                    </div>
                                                </td>
                                            </tr>
                                        {/each}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        {/if}
                    {:else if tab === 'alteryx'}
                        <div class="row">
                            <div class="col-md-12">
                                <h4>Alteryx</h4>
                                <label>Users Allowed:</label>
                                <textarea id="emails-textarea" type="text" bind:value={alteryxEmails} placeholder="example1@mail.com, example2@mail.com ..." class="form-control"></textarea>
                                    <p><small>Input email accounts separated by a comma</small></p>
                                <button class="btn btn-success mt-2" on:click={ updateAlteryxEmails }>Update</button>
                            </div>
                        </div>
                    {:else if tab === 'api_access'}
                        <div class="row">
                            <div class="col-md-12">
                                <h4>API Access</h4>
                                <label>Users Allowed:</label>
                                <textarea id="emails-textarea" type="text" bind:value={apiReportsEmails} placeholder="example1@mail.com, example2@mail.com ..." class="form-control"></textarea>
                                    <p><small>Input email accounts separated by a comma</small></p>
                                <button class="btn btn-success mt-2" on:click={ updateApiUsersAllowed }>Update</button>
                            </div>
                        </div>
                    {/if}
                {/if}
            {/if}
        </div>
    </div>

    <style>
        #autocomplete > ul > li:hover{
            z-index: 2;
            color: #fff;
            background-color: #007bff;
            border-color: #007bff;
        }
        #permissions-org-list{
            position: absolute !important;
            transform: translate3d(0px, 36px, 0px) !important;
            top: 0px !important;
            left: 0px !important;
            width: 100% !important;
            will-change: transform !important;
            overflow-y: scroll !important;
            height: 300px !important;
        }
    </style>
</main>

<!-- Add/edit external user -->
<div class="modal fade" id="addExternalUser" tabindex="-1" role="dialog" aria-labelledby="addExternalUser" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="addExternalUserLabel">
                    New External User
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form on:submit|preventDefault={onExternalUserSave}>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            {#if externalUserErrorMessage.show}
                                <div id="external-modal-error" class="alert alert-danger" role="alert">
                                    {externalUserErrorMessage.text}
                                    <button type="button" class="close" on:click={ () => externalUserErrorMessage.show = false}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            {/if}
                            <div class="form-group">
                                <label for="external-name">*Name</label>
                                <input  bind:value={externalUser.name} type="text" class="form-control" name="external-name" id="external-name" placeholder="John Doe">
                            </div>
                            <div class="form-group">
                                <label for="external-email">*Email</label>
                                <input  bind:value={externalUser.email} type="text" class="form-control" name="external-email" id="external-email" placeholder="example@mail.com">
                            </div>
                            <PasswordValidator confirmPassword={true}
                                bind:validPassword={validPassword} on:change={(e) => passwordChanged(e.detail.value)} />
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" on:click={cleanExternalUser}>Close</button>

                    <button type="submit" disabled={!validPassword.valid} class="btn btn-success">Save</button>
                </div>
            </form>
        </div>
    </div>
</div>
